// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__PfJpE","col":"CardReaderDesc_col__1r-xo","label":"CardReaderDesc_label__3COnT"};